export const isIE = () => {
    const ua = navigator.userAgent;
    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;
};

export function getLang() {
    return $('html').attr('lang');
}

export function getParameterByName(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
        results = regex.exec(location.search);
    return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getWstaticUrl() {
    let env = getSeviceEnv();
    let url = '';
    switch (env) {
        case 'opdev':
            url = 'https://op-wstatic.ncsoft.com';
            break;
        case 'sandbox':
            url = 'https://sb-static.plaync.com/';
            break;
        case 'rc':
            url = 'https://rc-wstatic.plaync.co.kr';
            break;
        default:
            url = 'https://wstatic-cdn.plaync.com';
            break;
    }
    return url;
}

const getSeviceEnv = () => {
    if (/^(rc-tw.)/.test(location.hostname)) {
        return 'rc-tw';
    } else if (/^(tw.)/.test(location.hostname)) {
        return 'tw';
    } else if (/^(rc\.|rc-)/.test(location.hostname)) {
        return 'rc';
    } else if (/^opdev/.test(location.hostname)) {
        return 'opdev';
    } else if (/^sb-/.test(location.hostname)) {
        return 'sandbox';
    } else if(/^local/.test(location.hostname)){
        return 'opdev';
    } else {
        return 'live';
    }
};




